<!-- 锚点图 -->
<template>
    <div class="msg-image uk-position-relative">
        <img ref="img" :src="carrierImg" alt="" srcset="" />
        <!-- 锚点 -->
        <span v-if="anchorShow || false" class="uk-position-absolute" style="left: 0; top: 0">
            <span v-for="(item, key) in equiPoint" :key="key" class="uk-position-absolute"
                :style="`left:${imgRate * item.xpos}px;top:${imgRate * item.ypos}px;`">
                <el-tooltip placement="top">
                    <i v-if="item.xpos && item.ypos" v-icon="['equiTypeConvert', item.deviceCatalog]"
                        class="color-theme"></i>
                    <div slot="content">
                        <div>{{ item.carrierDeviceName }}</div>
                        <!-- <div>{{item.description}}</div> -->
                        <div v-if="item.probeValue">
                            <div v-if="item.probeValue.temp">
                                <span>
                                    <span>
                                        <span>
                                            {{ $t('integration.temperature_detection_value') }}:<span
                                                v-range="[item.probeValue.temp.val, item.probeValue.temp]">
                                                {{ item.probeValue.temp.val }}{{ unit['temp'].name }}</span>
                                        </span>
                                        <span v-if="item.probeValue.temp.max && item.probeValue.temp.min">
                                            ({{ item.probeValue.temp.min }}{{ unit['temp'].name }} ~ {{
                                                item.probeValue.temp.max }}{{ unit['temp'].name }})
                                        </span>
                                    </span>
                                    -
                                    <span>{{ $timetransition(item.probeValue.temp.time) }}</span>
                                </span>
                            </div>
                            <div v-if="item.probeValue.hum">
                                <span>
                                    <span>
                                        <span>{{ $t('integration.humidity_detection_value') }}:
                                            <span v-range="[item.probeValue.hum.val, item.probeValue.hum]"> {{
                                                item.probeValue.hum.val }}{{ unit['hum'].name }} </span>
                                        </span>
                                        <span v-if="item.probeValue.hum.max && item.probeValue.hum.min">
                                            ({{ item.probeValue.hum.min }}{{ unit['hum'].name }} ~ {{
                                                item.probeValue.hum.max }}{{ unit['hum'].name }})
                                        </span></span>
                                    -
                                    <span>{{ $timetransition(item.probeValue.hum.time) }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </el-tooltip>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        // 设备列表
        deviceList: {
            type: Array,
        },
        // 监测点图片 的 src
        carrierImg: {},
        // 控制所有锚点的显示和隐藏
        anchorShow: {
            type: [Boolean, Number],
            default: true
        }
    },
    data() {
        return {
            imgRate: 0,
            equiPoint: {}
        };
    },
    methods: {
        initEquiPoint() {
            this.equiPoint = this.deviceList.map(item => {
                if (typeof item.probeValue === 'string')
                    item.probeValue = JSON.parse(item.probeValue);
                return item;
            })
        }
    },
    mounted() {
        const img = new Image();
        img.src = this.carrierImg;
        img.onload = () => {
            const imgWidth = img.width;
            const imgBoxWidth = this.$refs['img'].width;
            const imgBoxHeight = this.$refs['img'].height;
            if (imgBoxWidth > imgBoxHeight) {
                this.imgRate = imgBoxWidth / imgWidth;
            } else {
                this.imgRate = imgBoxHeight / imgWidth;
            }
        };
        this.initEquiPoint();
    }
};
</script>

<style scoped lang="scss">
$border-color: #ccc;

.msg-image {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        object-position: left top;
    }
}
</style>
